import { Injectable } from '@angular/core';

@Injectable()
export class CategorieModel {

  constructor() { }
  public lib_cat:string;
}